module.exports = __webpack_public_path__ + "img/SC9-Occupation_Rating.08acec24.png";